<template>
  <div
    class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-[25px] mb-[25px]"
  >
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content">
        <div class="form-check">
          <input type="checkbox" class="cursor-pointer" />
        </div>
        <div class="mt-[20px] md:mt-[30px] lg:mt-[40px] flex items-center">
          <div
            class="leading-none text-primary-500 ltr:mr-[10px] rtl:ml-[10px]"
          >
            <i class="material-symbols-outlined !text-[45px]"> folder_open </i>
          </div>
          <h6 class="mb-0 text-[15px]">Projects</h6>
        </div>
        <div
          class="mt-[20px] md:mt-[30px] lg:mt-[40px] flex items-center justify-between"
        >
          <div class="block text-sm text-black dark:text-white">159 Files</div>
          <div class="block text-sm text-black dark:text-white">4.5 GB</div>
        </div>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content">
        <div class="form-check">
          <input type="checkbox" class="cursor-pointer" />
        </div>
        <div class="mt-[20px] md:mt-[30px] lg:mt-[40px] flex items-center">
          <div
            class="leading-none text-secondary-500 ltr:mr-[10px] rtl:ml-[10px]"
          >
            <i class="material-symbols-outlined !text-[45px]"> folder_open </i>
          </div>
          <h6 class="mb-0 text-[15px]">Documents</h6>
        </div>
        <div
          class="mt-[20px] md:mt-[30px] lg:mt-[40px] flex items-center justify-between"
        >
          <div class="block text-sm text-black dark:text-white">522 Files</div>
          <div class="block text-sm text-black dark:text-white">5.5 GB</div>
        </div>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content">
        <div class="form-check">
          <input type="checkbox" class="cursor-pointer" />
        </div>
        <div class="mt-[20px] md:mt-[30px] lg:mt-[40px] flex items-center">
          <div
            class="leading-none text-success-500 ltr:mr-[10px] rtl:ml-[10px]"
          >
            <i class="material-symbols-outlined !text-[45px]"> folder_open </i>
          </div>
          <h6 class="mb-0 text-[15px]">Media</h6>
        </div>
        <div
          class="mt-[20px] md:mt-[30px] lg:mt-[40px] flex items-center justify-between"
        >
          <div class="block text-sm text-black dark:text-white">995 Files</div>
          <div class="block text-sm text-black dark:text-white">7.5 GB</div>
        </div>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content">
        <div class="form-check">
          <input type="checkbox" class="cursor-pointer" />
        </div>
        <div class="mt-[20px] md:mt-[30px] lg:mt-[40px] flex items-center">
          <div class="leading-none text-danger-500 ltr:mr-[10px] rtl:ml-[10px]">
            <i class="material-symbols-outlined !text-[45px]"> folder_open </i>
          </div>
          <h6 class="mb-0 text-[15px]">Applications</h6>
        </div>
        <div
          class="mt-[20px] md:mt-[30px] lg:mt-[40px] flex items-center justify-between"
        >
          <div class="block text-sm text-black dark:text-white">39 Files</div>
          <div class="block text-sm text-black dark:text-white">3.8 GB</div>
        </div>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content">
        <div class="form-check">
          <input type="checkbox" class="cursor-pointer" />
        </div>
        <div class="mt-[20px] md:mt-[30px] lg:mt-[40px] flex items-center">
          <div
            class="leading-none text-warning-500 ltr:mr-[10px] rtl:ml-[10px]"
          >
            <i class="material-symbols-outlined !text-[45px]"> folder_open </i>
          </div>
          <h6 class="mb-0 text-[15px]">ET Template</h6>
        </div>
        <div
          class="mt-[20px] md:mt-[30px] lg:mt-[40px] flex items-center justify-between"
        >
          <div class="block text-sm text-black dark:text-white">75 Files</div>
          <div class="block text-sm text-black dark:text-white">2.2 GB</div>
        </div>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content">
        <div class="form-check">
          <input type="checkbox" class="cursor-pointer" />
        </div>
        <div class="mt-[20px] md:mt-[30px] lg:mt-[40px] flex items-center">
          <div class="leading-none text-info-500 ltr:mr-[10px] rtl:ml-[10px]">
            <i class="material-symbols-outlined !text-[45px]"> folder_open </i>
          </div>
          <h6 class="mb-0 text-[15px]">React Template</h6>
        </div>
        <div
          class="mt-[20px] md:mt-[30px] lg:mt-[40px] flex items-center justify-between"
        >
          <div class="block text-sm text-black dark:text-white">357 Files</div>
          <div class="block text-sm text-black dark:text-white">8.5 GB</div>
        </div>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content">
        <div class="form-check">
          <input type="checkbox" class="cursor-pointer" />
        </div>
        <div class="mt-[20px] md:mt-[30px] lg:mt-[40px] flex items-center">
          <div class="leading-none text-purple-500 ltr:mr-[10px] rtl:ml-[10px]">
            <i class="material-symbols-outlined !text-[45px]"> folder_open </i>
          </div>
          <h6 class="mb-0 text-[15px]">Material UI</h6>
        </div>
        <div
          class="mt-[20px] md:mt-[30px] lg:mt-[40px] flex items-center justify-between"
        >
          <div class="block text-sm text-black dark:text-white">159 Files</div>
          <div class="block text-sm text-black dark:text-white">4.5 GB</div>
        </div>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content">
        <div class="form-check">
          <input type="checkbox" class="cursor-pointer" />
        </div>
        <div class="mt-[20px] md:mt-[30px] lg:mt-[40px] flex items-center">
          <div
            class="leading-none text-black dark:text-white ltr:mr-[10px] rtl:ml-[10px]"
          >
            <i class="material-symbols-outlined !text-[45px]"> folder_open </i>
          </div>
          <h6 class="mb-0 text-[15px]">WP Themes</h6>
        </div>
        <div
          class="mt-[20px] md:mt-[30px] lg:mt-[40px] flex items-center justify-between"
        >
          <div class="block text-sm text-black dark:text-white">522 Files</div>
          <div class="block text-sm text-black dark:text-white">5.5 GB</div>
        </div>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content">
        <div class="form-check">
          <input type="checkbox" class="cursor-pointer" />
        </div>
        <div class="mt-[20px] md:mt-[30px] lg:mt-[40px] flex items-center">
          <div class="leading-none text-danger-500 ltr:mr-[10px] rtl:ml-[10px]">
            <i class="material-symbols-outlined !text-[45px]"> folder_open </i>
          </div>
          <h6 class="mb-0 text-[15px]">Personal Photos</h6>
        </div>
        <div
          class="mt-[20px] md:mt-[30px] lg:mt-[40px] flex items-center justify-between"
        >
          <div class="block text-sm text-black dark:text-white">995 Files</div>
          <div class="block text-sm text-black dark:text-white">7.5 GB</div>
        </div>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content">
        <div class="form-check">
          <input type="checkbox" class="cursor-pointer" />
        </div>
        <div class="mt-[20px] md:mt-[30px] lg:mt-[40px] flex items-center">
          <div
            class="leading-none text-primary-500 ltr:mr-[10px] rtl:ml-[10px]"
          >
            <i class="material-symbols-outlined !text-[45px]"> folder_open </i>
          </div>
          <h6 class="mb-0 text-[15px]">Mobile Apps</h6>
        </div>
        <div
          class="mt-[20px] md:mt-[30px] lg:mt-[40px] flex items-center justify-between"
        >
          <div class="block text-sm text-black dark:text-white">39 Files</div>
          <div class="block text-sm text-black dark:text-white">3.8 GB</div>
        </div>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content">
        <div class="form-check">
          <input type="checkbox" class="cursor-pointer" />
        </div>
        <div class="mt-[20px] md:mt-[30px] lg:mt-[40px] flex items-center">
          <div
            class="leading-none text-secondary-500 ltr:mr-[10px] rtl:ml-[10px]"
          >
            <i class="material-symbols-outlined !text-[45px]"> folder_open </i>
          </div>
          <h6 class="mb-0 text-[15px]">Important Files</h6>
        </div>
        <div
          class="mt-[20px] md:mt-[30px] lg:mt-[40px] flex items-center justify-between"
        >
          <div class="block text-sm text-black dark:text-white">75 Files</div>
          <div class="block text-sm text-black dark:text-white">2.2 GB</div>
        </div>
      </div>
    </div>
    <div
      class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
    >
      <div class="trezo-card-content">
        <div class="form-check">
          <input type="checkbox" class="cursor-pointer" />
        </div>
        <div class="mt-[20px] md:mt-[30px] lg:mt-[40px] flex items-center">
          <div
            class="leading-none text-warning-500 ltr:mr-[10px] rtl:ml-[10px]"
          >
            <i class="material-symbols-outlined !text-[45px]"> folder_open </i>
          </div>
          <h6 class="mb-0 text-[15px]">Angular Template</h6>
        </div>
        <div
          class="mt-[20px] md:mt-[30px] lg:mt-[40px] flex items-center justify-between"
        >
          <div class="block text-sm text-black dark:text-white">357 Files</div>
          <div class="block text-sm text-black dark:text-white">8.5 GB</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Assets",
});
</script>
